/**
 * @generated SignedSource<<17317bae09d28757d67d7f0e4b56a93b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OtherCostBulkCreateInput = {
  charge: number;
  cost: number;
  date: string;
  name: string;
};
export type OtherCostsBulkCreateMutation$variables = {
  input: ReadonlyArray<OtherCostBulkCreateInput>;
  project_id: number;
};
export type OtherCostsBulkCreateMutation$data = {
  readonly action_other_cost_bulk_create: {
    readonly account: {
      readonly id: number;
    } | null | undefined;
    readonly project: {
      readonly id: number;
      readonly other_costs: ReadonlyArray<{
        readonly charge: number | null | undefined;
        readonly cost: number | null | undefined;
        readonly date: string | null | undefined;
        readonly id: number;
        readonly name: string;
      }>;
    } | null | undefined;
  };
};
export type OtherCostsBulkCreateMutation = {
  response: OtherCostsBulkCreateMutation$data;
  variables: OtherCostsBulkCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "project_id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      },
      {
        "kind": "Variable",
        "name": "project_id",
        "variableName": "project_id"
      }
    ],
    "concreteType": "OtherCostBulkCreateOutput",
    "kind": "LinkedField",
    "name": "action_other_cost_bulk_create",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "projects",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "order_by",
                "value": {
                  "date": "asc"
                }
              }
            ],
            "concreteType": "other_costs",
            "kind": "LinkedField",
            "name": "other_costs",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": "date",
                "args": null,
                "kind": "ScalarField",
                "name": "date_runn",
                "storageKey": null
              },
              {
                "alias": "cost",
                "args": null,
                "kind": "ScalarField",
                "name": "cost_private",
                "storageKey": null
              },
              {
                "alias": "charge",
                "args": null,
                "kind": "ScalarField",
                "name": "charge_private",
                "storageKey": null
              }
            ],
            "storageKey": "other_costs(order_by:{\"date\":\"asc\"})"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "accounts",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OtherCostsBulkCreateMutation",
    "selections": (v2/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OtherCostsBulkCreateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "4026397627c1e8e39467510b70593bcf",
    "id": null,
    "metadata": {},
    "name": "OtherCostsBulkCreateMutation",
    "operationKind": "mutation",
    "text": "mutation OtherCostsBulkCreateMutation(\n  $input: [OtherCostBulkCreateInput!]!\n  $project_id: Int!\n) {\n  action_other_cost_bulk_create(input: $input, project_id: $project_id) {\n    project {\n      id\n      other_costs(order_by: {date: asc}) {\n        id\n        name\n        date: date_runn\n        cost: cost_private\n        charge: charge_private\n      }\n    }\n    account {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0a7872125fec6142899512b97e8e20d5";

export default node;
